import { Styles, dividerClasses, generateClasses } from 'netline-ui';

export const mobilePreferencesClasses = generateClasses('MobilePreferences', [
  'root',
  'paper',
  'divider',
  'parcel',
] as const);

const styles: Styles = ({ theme: { palette, spacing } }) => ({
  [`&.${mobilePreferencesClasses.root}`]: {
    position: 'absolute',
    inset: 0,
    zIndex: 1000,
    backgroundColor: palette.common.white,
  },

  [`.${mobilePreferencesClasses.paper}`]: {
    padding: spacing(0, 2, 1.5, 2),
  },

  [`.${dividerClasses.root}`]: {
    margin: spacing(1, 0),
  },
});

export default styles;
